// src/components/shared/FileSelectButton.jsx
import React, { useRef } from 'react'

function FileSelectButton ({ onFileSelected, disabled, className = '' }) {
  const inputRef = useRef(null)

  const handleClick = () => {
    inputRef.current?.click()
  }

  const handleChange = e => {
    const selected = e.target.files?.[0]
    if (selected) onFileSelected(selected)
    e.target.value = '' // erlaubt erneutes Auswählen derselben Datei
  }

  return (
    <>
      <button
        type='button'
        className={`btn ${className}`.trim()}
        onClick={handleClick}
        disabled={disabled}
      >
        Rechnung auswählen
      </button>
      <input
        ref={inputRef}
        type='file'
        accept='.pdf,.png,.jpg,.jpeg,.bmp'
        style={{ display: 'none' }}
        onChange={handleChange}
      />
    </>
  )
}

export default FileSelectButton
